<template>
  <router-view/>
</template>

<script>
export default {
  name: 'AdminItems',
}
</script>

<style scoped>
</style>
